<template>
    <referrals-confirmation :heading="confirmationHeading" type="success">
        <template #content>
            <referral-details :referral="referral"></referral-details>
        </template>

        <template #footer>
            <common-buttons>
                <common-button
                    :route="{ name: 'referrals.received.referrals' }"
                    :label="$t('pages.referrals.show.confirmed.button')"
                    size="large"
                    type="primary"
                ></common-button>
            </common-buttons>
        </template>
    </referrals-confirmation>
</template>

<script>
    import ReferralsConfirmation from 'components/page-elements/ReferralsConfirmation'
    import ReferralDetails from 'components/page-elements/referrals/ReferralDetails'

    export default {
        components: {
            ReferralsConfirmation,
            ReferralDetails,
        },

        props: {
            referral: { type: Object, required: true },
        },

        computed: {
            confirmationHeading() {
                if (this.$route.query.successfully_rescheduled)
                    return this.$t('pages.referrals.show.confirmed.heading_successfully_rescheduled')
                else return this.$t('pages.referrals.show.confirmed.heading')
            },
        },
    }
</script>
